var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'md-button',_vm.$props,false),[(!_vm.disabled)?[_vm._t("default")]:[_vm._v(" Processing... ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }